import React, { Component } from "react";
import { Link } from "react-router-dom";
import { PageHandler } from "../pageHandler";
import { v4 } from "uuid";
import BamboraSvgIcon from "../../common/bamboraSvgIcon";
import { FormattedMessage } from "react-intl";

function parsePaginationParams(query, searchParam) {
  const limit = query && query.limit ? parseInt(query.limit, 10) : 20;
  const offset = query && query.offset ? parseInt(query.offset, 10) : 0;
  return {
    limit,
    offset,
    searchParam,
  };
}

class Pagination extends Component {
  componentWillReceiveProps(nextProps) {
    const currentPaginationParams = parsePaginationParams(this.props.query, nextProps.searchParam);
    const nextPaginationParams = parsePaginationParams(nextProps.query, nextProps.searchParam);
    const newOffsetAvailable = currentPaginationParams.offset !== nextPaginationParams.offset;
    const newLimitAvailable = currentPaginationParams.limit !== nextPaginationParams.limit;
    if (newOffsetAvailable || newLimitAvailable) {
      this.props.fetchPage();
    }
  }

  setStartPage(currentPage) {
    return currentPage > 2 ? currentPage - 2 : 1;
  }

  setLastPage(currentPage, startPage, totalPages) {
    if (totalPages < 2) {
      return totalPages;
    }
    let lastPage = currentPage + 2 < totalPages ? currentPage + 2 : totalPages;

    if (currentPage < 3 && totalPages < lastPage) {
      lastPage += 3 - currentPage;
    }

    if (totalPages < 3) {
      lastPage = 2;
    }

    if (totalPages === 1) {
      lastPage = 1;
    }

    return lastPage;
  }

  setPages({ query, total }) {
    const { offset, limit } = parsePaginationParams(query);
    const pagination = {};
    pagination.totalPages = Math.ceil(total / limit);
    pagination.currentPage = Math.floor(offset / limit) + 1;
    return pagination;
  }

  render() {
    let pagination = this.setPages(this.props);
    let startPage = this.setStartPage(pagination.currentPage);
    let lastPage = this.setLastPage(pagination.currentPage, startPage, pagination.totalPages);
    let pages = [];
    const { offset, limit, searchParam } = parsePaginationParams(this.props.query, this.props.searchParam);
    for (var i = startPage; i <= lastPage; i++) {
      pages.push(i);
    }

    if (this.props.total === 0) {
      return null;
    }

    return (
      <div className="pagination">
        {offset >= limit && (
          <div className="pull-left pagination-arrow-link">
            <Link
              to={{
                pathname: this.props.pathname,
                query: {
                  offset: offset - limit,
                  limit,
                  searchParam: searchParam,
                },
              }}
            >
              <BamboraSvgIcon icon="arrow-left" className="rotate-0" />
              <FormattedMessage
                id="pagination-prev"
                defaultMessage={"Prev"}
                description="Link to previous page in the pagination module"
              />
            </Link>
          </div>
        )}

        <div className="pagination-numbers">
          {pagination.currentPage > 3 && pagination.currentPage + 2 >= 6 ? (
            <li key={v4()}>
              <Link
                to={{
                  pathname: this.props.pathname,
                  query: {
                    offset: 0,
                    limit,
                    searchParam: searchParam,
                  },
                }}
              >
                1 ...
              </Link>
            </li>
          ) : null}
          {pages.length > 1
            ? pages.map((page) => (
                <PageHandler
                  key={v4()}
                  limit={limit}
                  offset={offset}
                  pathname={this.props.pathname}
                  searchParam={searchParam}
                  page={page}
                />
              ))
            : null}
          {pagination.totalPages > 3 && pagination.currentPage + 2 < pagination.totalPages ? (
            <li key={v4()}>
              <Link
                to={{
                  pathname: this.props.pathname,
                  query: {
                    offset: (pagination.totalPages - 1) * limit,
                    limit,
                    searchParam: searchParam,
                  },
                }}
              >
                ... {pagination.totalPages}
              </Link>
            </li>
          ) : null}
        </div>

        {offset < this.props.total - limit && (
          <div className="pull-right pagination-arrow-link">
            <Link
              to={{
                pathname: this.props.pathname,
                query: {
                  offset: offset + limit,
                  limit,
                  searchParam: searchParam,
                },
              }}
            >
              <FormattedMessage
                id="pagination-next"
                defaultMessage={"Next"}
                description="Link to next page in the pagination module"
              />
              <BamboraSvgIcon icon="arrow-left" className="rotate-180" />
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default Pagination;
